module.exports = __webpack_public_path__ + "media/country_flags/sy-c9296626.png";